import React, { useRef, useState } from "react";
import { useOutsideClick } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as MoreIcon } from "src/icons/more-vert.svg";
import { ReactComponent as DeleteIcon } from "src/icons/delete-outlined.svg";
import { ReactComponent as DownloadIcon } from "./download.svg";

export default function CapturedMediaMenu({ onDownload, onDelete }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  useOutsideClick({
    ref: menuRef,
    handler: () => setIsOpen(false),
    enabled: isOpen
  });

  const handleDownload = () => {
    onDownload();
    setIsOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsOpen(false);
  };

  return (
    <div ref={menuRef}>
      <Menu
        elevationLevel={2}
        isOpen={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        icon={MoreIcon}
        iconFill="white"
        popoverProps={{ closeOnBlur: false }}
      >
        <MenuItem onClick={handleDownload} my="8px">
          <SvgContainer size="20px" fill="primary" mr="16px" icon={DownloadIcon} />
          <MenuItemText>{t("download")}</MenuItemText>
        </MenuItem>
        <MenuItem onClick={handleDelete} mb="8px">
          <SvgContainer size="20px" fill="primary" mr="16px" icon={DeleteIcon} />
          <MenuItemText>{t("buttons.delete")}</MenuItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
